import React from "react";
import "./Footer.css";

const Footer = () => {
  const today = new Date();
  const year = today.getFullYear();
  return (
    <>
    <div>
      <div className="footer-container p-3">
        <h4 className="copyright">
          Copyright <span>© {year} </span>by Shreerupmanijewellers & design by AppicLogics
        </h4>
      </div>
      </div>
    </>
  );
};

export default Footer;
